import { JDSHorizontalStepItemProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSHorizontalStepItemProps>
  ): React.FC<JDSHorizontalStepItemProps> =>
  (props: JDSHorizontalStepItemProps) => {
    return <Component {...props} />;
  };
